import type { RentalComparable } from '@realadvisor/listings/rental-cma';

export const toggleRentalSelection = (
  selection: RentalComparable[],
  item: RentalComparable,
): RentalComparable[] =>
  selection.some(value => value.id === item.id)
    ? selection.filter(value => value.id !== item.id)
    : [...selection, item];
